const downloadPDF = async (
  pdfUrl?: string,
  fileName: string = 'contract.pdf',
) => {
  if (!pdfUrl) throw new Error('No PDF URL');

  const response = await fetch(pdfUrl);

  if (!response.ok) {
    throw new Error('Download failed');
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};

export default downloadPDF;
